import { useListItem } from "@floating-ui/react";
import { ComponentProps, useContext } from "react";

import { Box } from "@design-system/Box/Box";
import { Clickable } from "@design-system/Clickable/Clickable";
import { Icon } from "@design-system/Icon/Icon";

import { DropdownContext } from "../../DropdownContext";

type Props = {
  label: string;
  onSelect?: () => void;
  icon?: ComponentProps<typeof Icon>["icon"];
  children?: React.ReactNode;
};

export const Option = ({ children, label, onSelect, icon }: Props) => {
  const { activeIndex, selectedIndex, getItemProps, handleSelect } =
    useContext(DropdownContext);

  const { ref, index } = useListItem({ label });

  const isActive = activeIndex === index;
  const isSelected = selectedIndex === index;

  return (
    <Clickable
      padding={8}
      ref={ref}
      role="option"
      aria-selected={isActive && isSelected}
      tabIndex={isActive ? 0 : -1}
      {...getItemProps({
        onClick: () => {
          onSelect?.();
          return handleSelect(index);
        },
      })}
      stretch
    >
      {children || (
        <Box gap={8} align="center">
          {icon && <Icon icon={icon} />}
          {label}
        </Box>
      )}
    </Clickable>
  );
};
